/*jshint esversion: 9 */
import React from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, hasValue, updateObject } from "../shared/utility";

import Button from "@material-ui/core/Button";
import Card from "../components/UI/Card/Card";
import classes from "./CrimeSubmission.css";
import * as actions from "../store/actions/index";
import Grid from "@material-ui/core/Grid";
import Form from "../components/UI/Form/Form";
import SectionHeading from "../components/UI/SectionHeading/SectionHeading";

const sectionName = "Property";

const mappedSelectPropFields = ["propertyType", "propertyColor"];

const mappedTextPropFields = [
  "propertyDescription",
  "propertyMake",
  "propertyModel",
  "propertySerialNo",
  "propertyQuantity",
  "propertyMarketValue",
  "propertyDamagedValue",
  //
  "id",
  "deleted",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

// const gridSpacing = 8; //0 or 8 or 16 or 24 or 32 or 40

class Property extends Form {
  state = {
    searching: false,
    editMode: true,
    itemProcessed: false,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    sectionName: sectionName,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    propertyDescription: {
      inputType: "text",
      value: "",
      label: "Property Description",
      validation: { required: true },
    },
    propertyType: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Property Type",
      listName: "propertyTypeList",
      codegroup: "29",
      validation: { required: true },
    },
    propertyMake: { inputType: "text", value: "", label: "Brand" },
    propertyModel: { inputType: "text", value: "", label: "Model" },
    propertySerialNo: { inputType: "text", value: "", label: "Serial #" },
    propertyColor: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Color",
      listName: "propertyColorList",
      codegroup: "161",
    },
    propertyQuantity: {
      inputType: "number",
      value: "",
      label: "How Many",
      validation: { required: true },
    },
    propertyMarketValue: {
      inputType: "number",
      value: "",
      label: "Market Value ($)",
    },
    propertyDamagedValue: {
      inputType: "number",
      value: "",
      label: "Damaged Value ($)",
    },
    //
    id: {
      inputType: "text",
      value: "-1",
      label: "ID",
      validation: { required: false },
    },
    deleted: {
      inputType: "text",
      value: "",
      label: "Deleted",
      validation: { required: false },
    },
  };

  addNewPropertyItem() {
    const newInstance = this.props.propertyArray.length;
    const propertyFields = null;
    const propertyItem = {
      propertyInstance: newInstance,
      propertyFields: propertyFields,
    };

    if (doLog())
      console.log("[Property] addNewPropertyItem propertyItem:", propertyItem);
    this.props.onAddToPropertyArray(this.props.propertyArray, propertyItem);
  }

  checkAndLoadConfig() {
    if (this.props.configuration != null) {
      if (doLog())
        console.log(
          "[Property] ciddbConnectionName:",
          this.props.configuration.ciddbConnectionName
        );
      if (
        this.props.configuration !== null &&
        this.props.configuration.ciddbConnectionName !== null
      ) {
        if (this.props.propertySelectFieldList === null) {
          this.props.onSetPropertySelectFieldList(mappedSelectPropFields);
        } else if (this.props.propertyTextFieldList === null) {
          this.props.onSetPropertyTextFieldList(mappedTextPropFields);
        }
      }
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[Property] componentDidMount state:", this.state);
    if (doLog()) console.log("[Property] componentDidMount props:", this.props);
    this.checkAndLoadConfig();
    //this.copyFieldValuesToState();
    this.setFieldRequiredSettings();
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[Property] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[Property] componentDidUpdate props:", this.props);
    this.checkAndLoadConfig();
    this.copyFieldValuesToState();
  }

  copyFieldValuesToState() {
    if (!this.state.itemProcessed) {
      if (doLog())
        console.log("[Property] copyFieldValuesToState item:", this.props.item);
      if (this.props.item !== null && this.props.item.propertyFields !== null) {
        const propertyFields = this.props.item.propertyFields;
        if (doLog())
          console.log(
            "[Property] copyFieldValuesToState propertyFields:",
            propertyFields
          );

        for (let field in this.state.mappedTextPropFields) {
          const fieldName = this.state.mappedTextPropFields[field];
          if (doLog())
            console.log(
              "[Property] copyFieldValuesToState text field:",
              fieldName
            );
          if (
            hasValue(propertyFields[fieldName]) &&
            hasValue(propertyFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: propertyFields[fieldName].value,
              }),
            });
          }
        }

        for (let field in this.state.mappedSelectPropFields) {
          const fieldName = this.state.mappedSelectPropFields[field];
          if (doLog())
            console.log(
              "[Property] copyFieldValuesToState select field:",
              fieldName
            );
          if (
            hasValue(propertyFields[fieldName]) &&
            hasValue(propertyFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: propertyFields[fieldName].value,
              }),
            });
          }
        }
      }
      this.setState({ itemProcessed: true });
    }
  }

  handleAddButton = () => {
    if (doLog()) console.log("handleAddButton");
    this.addNewPropertyItem();
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[Property] handleDeleteButton");
    const propertyItem = this.props.item;

    if (doLog())
      console.log("[Property] handleDeleteButton propertyItem:", propertyItem);
    if (
      hasValue(propertyItem.propertyFields) &&
      hasValue(propertyItem.propertyFields.id) &&
      hasValue(propertyItem.propertyFields.id.value) &&
      propertyItem.propertyFields.id.value !== "-1"
    ) {
      if (doLog())
        console.log("[Property] handleDeleteButton setting deleted to Y");
      this.setState({
        deleted: updateObject(this.state.deleted, {
          value: "Y",
        }),
      });
      //update the propertyArray so that this change doesn't get overridden in copyFieldValuesToState()
      const newPropertyArray = [];
      const length = this.props.propertyArray.length;
      for (let i = 0; i < length; i++) {
        let propertyFields = null;
        const item = this.props.propertyArray[i];
        if (doLog())
          console.log("[Property] handleDeleteButton item[" + i + "]:", item);
        if (item === propertyItem) item.propertyFields.deleted.value = "Y";
        propertyFields = item.propertyFields;
        console.log(
          "[Property] handleDeleteButton propertyFields:",
          propertyFields
        );
        newPropertyArray.push({
          propertyFields: propertyFields,
          propertyInstance: i,
        });
        this.props.onSetPropertyArray(newPropertyArray);
      }
    } else {
      this.props.onDeleteFromPropertyArray(
        this.props.propertyArray,
        propertyItem
      );
    }
  };

  setFieldRequiredSettings() {
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Property]setFieldRequiredSettings text field:", fieldName);
      // if (doLog()) console.log("[Property]setFieldRequiredSettings required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }

    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Property]setFieldRequiredSettings select field:", fieldName);
      // if (doLog()) console.log("[Property]setFieldRequiredSettings select required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }
  }

  render() {
    if (doLog()) console.log("[Property]render item:", this.props.item);
    if (doLog())
      console.log(
        "[Property] render propertyInstance:",
        this.props.item.propertyInstance
      );
    let informationSection = null;
    if (this.props.item.propertyInstance === 0) {
      informationSection = (
        <Grid item xs={12}>
          <p className={classes.Information}>
            Next, please enter information about the property item(s) involved
            in the incident.
          </p>
        </Grid>
      );
    }

    let mainSection = null;
    if (this.state.deleted.value !== "Y") {
      mainSection = (
        <Card>
          <Grid container item className={classes.Card}>
            <SectionHeading sectionTitle="Property Details" />
            {informationSection}
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={12}>
              {this.getFormField("propertyDescription", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("propertyType", false, true)}
            </Grid>
            <Grid item xs={4} />
            <Grid item xs={4} />
            <Grid item xs={4}>
              {this.getFormField("propertyMake", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("propertyModel", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("propertySerialNo", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("propertyColor", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("propertyQuantity", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("propertyMarketValue", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("propertyDamagedValue", false, true)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleAddButton.bind(this)}
              >
                Add another
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleDeleteButton.bind(this)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
        </Card>
      );
    }

    return (
      mainSection
    );
  }
}

const mapStateToProps = (state) => {
  // if (doLog()) console.log('Property.mapStateToProps token:', state.auth.token);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    //
    propertyTypeList: state.trans.propertyTypeList,
    propertyColorList: state.trans.vehicleColorList, //use vehicle colors to avoid issue when using the same codeGroupID
    //
    stateList: state.trans.stateList,
    //
    propertyArray: state.trans.propertyArray,
    propertySelectFieldList: state.trans.propertySelectFieldList,
    propertyTextFieldList: state.trans.propertyTextFieldList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
    customTextList: state.trans.customTextList,
    requiredFieldList: state.trans.requiredFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchValidCodeLists: (ori, token, listName, codeGroup) =>
      dispatch(actions.fetchValidCodeLists(ori, token, listName, codeGroup)),
    onAddToPropertyArray: (propertyArray, propertyItem) =>
      dispatch(actions.addToPropertyArray(propertyArray, propertyItem)),
    onDeleteFromPropertyArray: (propertyArray, propertyItem) =>
      dispatch(actions.deleteFromPropertyArray(propertyArray, propertyItem)),
    onSetPropertyArray: (propertyArray) =>
      dispatch(actions.setPropertyArray(propertyArray)),
    onSetPropertySelectFieldList: (fieldList) =>
      dispatch(actions.setPropertySelectFieldList(fieldList)),
    onSetPropertyTextFieldList: (fieldList) =>
      dispatch(actions.setPropertyTextFieldList(fieldList)),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Property)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Property);
